import UserServicesFactory from '../../user/Services/factory.js'
import {ReviewsRepositoriesFactory} from '../Repositories/factory.js'
import {ReviewsValueObjectsFactory} from '../ValueObjects/factory.js'
import {GetNewsCommentsReviewsUseCase} from './GetNewsCommentsReviewsUseCase.js'
import {GetNewsRatingReviewsUseCase} from './GetNewsRatingReviewsUseCase.js'
import {PostNewsCommentReviewsUseCase} from './PostNewsCommentReviewsUseCase.js'

export default class ReviewsUseCasesFactory {
  static getNewsCommentsReviewsUseCase = ({config}) =>
    new GetNewsCommentsReviewsUseCase({
      config,
      repository: ReviewsRepositoriesFactory.httpCommentsRepository({config}),
      newsCommentsRequestValueObjectFactory: ReviewsValueObjectsFactory.newsCommentsRequestValueObject
    })

  static postNewsCommentReviewsUseCase = ({config}) =>
    new PostNewsCommentReviewsUseCase({
      config,
      repository: ReviewsRepositoriesFactory.httpCommentsRepository({config}),
      newsPostCommentRequestValueObjectFactory: ReviewsValueObjectsFactory.newsPostCommentRequestValueObject,
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      })
    })

  static getNewsRatingReviewsUseCase = ({config}) =>
    new GetNewsRatingReviewsUseCase({
      config,
      httpRatingRepository: ReviewsRepositoriesFactory.httpRatingRepository({
        config
      }),
      newsRatingRequestValueObjectFactory: ReviewsValueObjectsFactory.newsRatingRequestValueObject
    })
}
